import { onBeforeMount, onUnmounted, ref, unref, type MaybeRef } from 'vue'
import type { Message } from '#entities/message'
import { messageEditEventBus } from './message-edit-event-bus'

export function useEditingMessage(chatId: MaybeRef<number>) {
  const editingMessage = ref<Message | null>(null)

  const onEditingTriggered = (message: Message | null) => {
    editingMessage.value = message
  }

  onBeforeMount(() => {
    messageEditEventBus.on(unref(chatId), onEditingTriggered)
  })

  onUnmounted(() => {
    messageEditEventBus.off(unref(chatId), onEditingTriggered)
  })

  return editingMessage
}
